export default "__VITE_ASSET__DXShymlU__"